import { render, staticRenderFns } from "./CheckedBagLayout.vue?vue&type=template&id=0e4e38df&scoped=true&"
import script from "./CheckedBagLayout.vue?vue&type=script&lang=js&"
export * from "./CheckedBagLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4e38df",
  null
  
)

export default component.exports